export default __webpack_public_path__ + "static/media/Custom-HUD-Pop-Up (1 Layer).dba2fe38.jpg";